import axiosInstance from "./axiosConfig";

/**
 * Service for managing bank details (admin only)
 */
export const bankDetailsService = {
  /**
   * Get current bank details configuration
   * @returns {Promise<Object>} - Promise resolving to bank details data
   */
  async getBankDetails() {
    try {
      const response = await axiosInstance.get("/admin/bank-details");
      return response.data;
    } catch (error) {
      console.error("Error fetching bank details:", error);
      throw error;
    }
  },

  /**
   * Update bank details configuration
   * @param {Object} bankDetails - Bank details to update
   * @returns {Promise<Object>} - Promise resolving to updated bank details
   */
  async updateBankDetails(bankDetails) {
    try {
      const response = await axiosInstance.post(
        "/admin/bank-details",
        bankDetails
      );
      return response.data;
    } catch (error) {
      console.error("Error updating bank details:", error);
      throw error;
    }
  },
};
